import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Col,
  Form,
  Input,
  message,
  Modal,
  Radio,
  Row,
  Typography,
} from "antd";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import ClipLoader from "react-spinners/ClipLoader";
import * as yup from "yup";
import { Local_Variables, Login } from "../../actions/auth";
import Logo from "../../assets/images/logo-1.png";
// import Logo from "../../assets/images/rbl-logo.svg";
import { roleCCMapping, roleRouteMapping, RouteConstants } from "../../utils";
import { login } from "./../../actions/auth";
import InfoNPolicy from "./InfoNPolicies";
import usePayAxios from "../../config/useAxios";
import { apis } from "../../config/APIs";
import OTPComponent from "../Common/OTPComponent";
// import ReCaptchaComponent from "./ReCaptchaComponent";
import Loader from "../Loader";
import Captcha from "./CaptchaComponent";
import { ReloadOutlined } from "@ant-design/icons";
import { validateCaptcha } from "react-simple-captcha";
import useBrowserName from "../../config/useBrowserName";
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import endpoint from "../../config/Axios";
import SessionError from "../Common/SessionError";

const { Text, Title } = Typography;

message.config({
  maxCount: 3,
});

const LoginForm = () => {
  const browserName = useBrowserName();
  const [form] = Form.useForm();
  // State Hooks
  const [isEmp, setIsEmp] = React.useState(false);
  const [geolocationData, setGeolocationData] = useState({});
  // const [captchaToken, setCaptchaToken] = React.useState(null);
  const [isModalVisible, setIsModalVisible] = React.useState(false);
  const [otpData, setOtpData] = React.useState({});
  const [captchaError, setCaptchaError] = React.useState("");
  // ReCaptcha Ref
  // const recaptchaRef = useRef(null);

  // Axios Hooks

  const { onCall: verifyOTP, loading: verifyLoading } = usePayAxios({
    api: apis.verifyOTP,
    method: "post",
  });

  // Redux Hooks
  const dispatch = useDispatch();
  const loginResponse = useSelector((state) => state.auth.login || {});
  const loginLoading = useSelector((state) => state.auth.login?.loading);
  const history = useHistory();

  // Validation Schema
  const ValidationSchema = yup.object().shape(
    isEmp
      ? {
        emp_id: yup.string().required("Please provide employee id."),
        password: yup.string().required("Password is required."),
      }
      : {
        email: yup.string().email().required("Please provide valid email."),
        password: yup.string().required("Password is required."),
      },
  );

  // Function to handle successful login
  const setLoginData = (data) => {
    const isCorporateChecker = data?.is_corporate_checker;
    sessionStorage.setItem("token", data.auth_token);
    sessionStorage.setItem("name", data.name);
    sessionStorage.setItem("role", data.role);
    sessionStorage.setItem("user", data.user);
    sessionStorage.setItem("employee_id", data.employee_id);
    sessionStorage.setItem("user_id", data.user_id);
    sessionStorage.setItem(
      "is_admin",
      isCorporateChecker && !(data.is_admin || data.is_super_admin)
        ? "corporate"
        : data.is_admin || data.is_super_admin,
    );
    sessionStorage.setItem("is_Admin", data.is_admin || data.is_super_admin);
    sessionStorage.setItem("is_super_admin", data.is_super_admin);
    sessionStorage.setItem("is_corporate_checker", data.is_corporate_checker);
    sessionStorage.setItem("base_currency", JSON.stringify(data.base_currency));
    const decoded = jwtDecode(data.auth_token);
    sessionStorage.setItem("menu", JSON.stringify(data.menu ? data.menu : {}));
    sessionStorage.setItem("expiresAt", decoded.exp);
    sessionStorage.setItem("company_id", decoded.company_id);

    dispatch({
      type: Local_Variables,
      payload: {
        is_admin:
          isCorporateChecker && !(data.is_admin || data.is_super_admin)
            ? "corporate"
            : data.is_admin || data.is_super_admin,
      },
    });
    if (Object.keys(data.menu).includes("dashboard")) {
      history.push(RouteConstants.DASHBOARD);
    } else {
      if (
        roleRouteMapping[Object.keys(data.menu)[0]] &&
        (data.role?.includes("Employee") || data?.is_admin)
      )
        history.push(roleRouteMapping[Object.keys(data.menu)[0]]);
      else if (
        roleCCMapping[
        Object.keys(data.menu)?.filter((ele) => ele?.includes("cc_"))[0]
        ]
      )
        history.push(roleCCMapping[Object.keys(data.menu)[0]]);
    }
  };
  useEffect(() => {
    return () => {
      setOtpData({});
      dispatch({
        type: Login.RESET,
      });
    };
  }, []);

  // Effect to handle login response
  useEffect(() => {
    // Helper to get the error message as a string
    const getErrorMessage = () => {
      // If errors is an object, fall back to the message string
      if (
        typeof loginResponse?.data?.errors === "object" &&
        loginResponse?.data?.errors !== null
      ) {
        return loginResponse?.data?.message;
      }
      // Otherwise, use the string message or errors string
      return loginResponse?.data?.errors ?? loginResponse?.data?.message;
    };

    if (loginResponse.success) {
      if (loginResponse.data?.errors?.data?.current_logged_in) {
        // Handled by SessionError component below. We do nothing here to let the modal open.
      } else if (
        loginResponse.data?.response?.data?.otp_token
        //  &&
        // loginResponse.data.web_access_allowed !== false
      ) {
        // setLoginData(loginResponse.data);

        if (loginResponse.data?.response?.data)
          setOtpData((o) => ({
            ...o,
            ...loginResponse.data?.response?.data,
            otpSent: true,
          }));
      } else {
        const errorMessage = getErrorMessage();
        dispatch({
          type: Login.RESET,
        });
        reloadCaptcha();
        // setCaptchaToken(null);
        // if (recaptchaRef.current) {
        //   recaptchaRef.current.resetReCaptcha(); // Reset reCAPTCHA using ref
        // }
      }
    } else {
      const errorMessage = getErrorMessage();

      // 🚨 FIX: Check if the error is the 'current_logged_in' error
      const isCurrentLoggedInError =
        loginResponse.data?.errors?.data?.current_logged_in;

      if (errorMessage) {
        // Only show a message and reset state if it's NOT the active session error
        if (!isCurrentLoggedInError) {
          dispatch({
            type: Login.RESET,
          });
          reloadCaptcha();
        }
        // If it *is* the active session error, we rely on the SessionError modal.
        // The modal's Close button (cb prop) handles the RESET when the user dismisses it.
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loginResponse]);

  // Handle form submission
  const handleSubmit = (values) => {
    if (!validateCaptcha(values["captcha"])) {
      form.setFieldValue("captcha", "");
      setCaptchaError(true);
    } else {
      setCaptchaError(false);
      const payload = {};
      ["emp_id", "email", "password"].forEach((item) => {
        if (values[item]) payload[item] = values[item];
      });

      ValidationSchema.validate(payload)
        .then(async function ({ ...value }) {
          let public_key = `-----BEGIN PUBLIC KEY-----
  MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAv8caZGNMdbyyNtGTR1ke
  AXw3IKwMOKvSP6Oh72005J2Vr3Y29vDKKKQ0pFYsOk2HnTIdvwFuhE7r7+rHhy/a
  4ZDT4gFRzprcnAxQpMfnlodoIgLBqmpeg/E7X6Fhlq4P9dMoRtSCgpR2Fx9ka+eV
  P0v9Yv5B1C6ZQI6cywLA+/qO1UuX2Ul4MQ8VaQtAUA49CtEGGaE55k0jeIq1RQ3Z
  Z3ZleWsTkl9IlNYjJH6GcoeiDRfcvHaHh1reJRHkXh0RoY15g1js6VoSCusMiUDR
  nwKDkQbER9eW/Ljq/TixdmoOuo2W9qklW9awE7lkybxYL0kBl1iF6I88O5Zu+Y+7
  BwIDAQAB
  -----END PUBLIC KEY-----`;
          // Uncomment the following lines if you need to encrypt the password
          /*
          if (payload.password) {
            const encrypted = await encryptPassword(payload.password, public_key);
            payload.password = encrypted;
          }
          */
          // payload.captcha = captchaToken;
          setOtpData(payload);
          dispatch(login(payload));
          // setIsLoading(true);
        })
        .catch(function (err) {
          console.log(err);
        });
    }
  };

  // useEffect(() => {
  //   const fetchGeolocationData = async () => {
  //     try {
  //       const response = await axios.get("https://ipapi.co/json");
  //       const response1 = await endpoint.get("/api/v1/health-check");
  //       if (response?.data) {
  //         setGeolocationData({
  //           ...response,
  //           // country: `${response.data.city} (${response.data.country})`,
  //           country: `${response.data.city} (${response.data.country})`,
  //           ip_address: response.data.id,
  //         });
  //       }
  //     } catch (err) {
  //       console.error("Geolocation API Error:", err);
  //     }
  //   };

  //   fetchGeolocationData();
  // }, []);

  useEffect(() => {
    const GEO_TTL_MS = 24 * 60 * 60 * 1000; // 24 hours
    const CACHE_KEY = "geoip_data_v1";

    const delay = (ms) => new Promise((res) => setTimeout(res, ms));

    const fetchWithBackoff = async (url, maxRetries = 3) => {
      let attempt = 0;
      let lastError;
      while (attempt <= maxRetries) {
        try {
          const res = await axios.get(url, { timeout: 5000 });
          return res;
        } catch (err) {
          lastError = err;
          attempt += 1;
          if (attempt > maxRetries) break;
          // exponential backoff: 500ms, 1000ms, 2000ms...
          await delay(500 * Math.pow(2, attempt - 1));
        }
      }
      throw lastError;
    };

    const fetchGeolocationData = async () => {
      try {
        // Check cache first
        const cached = sessionStorage.getItem(CACHE_KEY);
        if (cached) {
          const parsed = JSON.parse(cached);
          const age = Date.now() - parsed._ts;
          if (age < GEO_TTL_MS && parsed.data) {
            setGeolocationData(parsed.data);
            return;
          }
        }

        // Not cached (or expired) — fetch with backoff
        const response = await fetchWithBackoff("https://ipapi.co/json", 2);

        if (response?.data) {
          const dataToStore = {
            _ts: Date.now(),
            data: {
              // keep only what you need to reduce storage size
              country: `${response.data.city} (${response.data.country})`,
              ip_address: response.data.ip || response.data.id || "",
              raw: response.data,
            },
          };
          try {
            sessionStorage.setItem(CACHE_KEY, JSON.stringify(dataToStore));
          } catch (e) {
            // ignore storage errors (e.g., quota), still proceed
            console.warn("Unable to write geo cache:", e);
          }
          setGeolocationData(dataToStore.data);
        }
      } catch (err) {
        console.error("Geolocation API Error (ipapi):", err?.message || err);
        // Optionally set a minimal fallback:
        setGeolocationData({
          country: "Unknown",
          ip_address: "",
        });
      }
    };

    fetchGeolocationData();
  }, []);

  const reloadCaptcha = () => {
    form.setFieldValue("captcha", "");
    const reloadElement = document.getElementById("reload_href");
    if (reloadElement) reloadElement.click();
  };

  return (
    <>
      <SessionError
        cb={() => {
          dispatch({
            type: Login.RESET,
          });
        }}
        open={loginResponse.data?.errors?.data?.current_logged_in === true}
      />
      {loginLoading && <Loader />}
      <div className="login-form">
        <img src={Logo} alt={"logo"} className="logo" />
        <div className="head-sec">
          <Title level={3} style={{ color: "white" }}>
            {otpData?.otpSent ? "Two-Step Authentication" : "Welcome back"}
          </Title>
          <Text className="text-dim" style={{ color: "white" }}>
            {otpData?.otpSent
              ? "Please enter the OTP received on the registered email address or mobile number."
              : "Please sign in to your account."}
          </Text>
        </div>
        {otpData?.otpSent ? (
          <>
            <OTPComponent
              isVerifyOtp={true}
              otpData={otpData}
              value={otpData?.otp || ""}  // Pass OTP value to control component
              source="LOGIN"
              setUserData={setOtpData}
              onChange={(val) => {
                setOtpData((o) => ({
                  ...o,
                  otp: val,
                }));
              }}
            />
            <div className="flex-center">
              <Button
                className="loginButton primaryButton mt2 ml2"
                onClick={() => {
                  verifyOTP({
                    data: {
                      email_id: otpData?.email,
                      source: "LOGIN",
                      otp_code: otpData?.otp,
                      otp_token: otpData?.otp_token,
                      device_source: browserName,
                      country: geolocationData?.country,
                      //country: "India",
                    },
                  })
                    .then((res) => {
                      if (res?.status) {
                        setLoginData(res?.response?.data);
                      }
                    })
                    .catch((err) => {
                      console.error("OTP Verification Error:", err);
                      setOtpData((o) => ({ ...o, otp: "" })); // Clear OTP on failure
                    });
                }}
                disabled={verifyLoading}
              >
                {verifyLoading ? (
                  <ClipLoader loading={verifyLoading} size={15} color="white" />
                ) : (
                  "Verify OTP"
                )}
              </Button>
            </div>
            <div className="mt2">
              <span
                className="mlHalf cursor emp-text"
                onClick={() => {
                  form.setFieldValue("captcha", "");
                  setOtpData({});
                  // if (recaptchaRef.current) {
                  //   recaptchaRef.current.resetReCaptcha(); // Reset reCAPTCHA when going back to login
                  // }
                }}
              >
                Back to Login
              </span>
            </div>
          </>
        ) : (
          <>
            <Form
              form={form}
              onFinish={handleSubmit}
              layout="vertical"
              onValuesChange={(changedValues, allValues) => {
                if (!allValues.captcha || allValues.captcha?.length == 6) {
                  setCaptchaError(false);
                }
              }}
            >
              {isEmp ? (
                <Form.Item
                  label="Emp ID"
                  name="emp_id"
                  rules={[
                    {
                      required: true,
                      message: "Please input your employee id",
                    },
                    {
                      pattern: /^[A-Za-z0-9]{1,25}$/,
                      message: "Enter valid employee id",
                    },
                  ]}
                >
                  <Input placeholder="Enter employee id" />
                </Form.Item>
              ) : (
                <Form.Item
                  label={<span style={{ color: "white" }}>Email Address</span>}
                  name="email"
                  rules={[
                    {
                      type: "email",
                      message: "Please provide valid email",
                    },
                    {
                      required: true,
                      message: "Please provide valid email",
                    },
                  ]}
                >
                  <Input placeholder="Enter Email" />
                </Form.Item>
              )}

              <Form.Item
                label={<span style={{ color: "white" }}>Password</span>}
                name="password"
                placeholder="Enter password"
                rules={[
                  {
                    required: true,
                    message: "Password is required",
                  },
                ]}
              >
                <Input.Password placeholder="Enter password" />
              </Form.Item>

              {/* Integrate ReCaptchaComponent here */}
              {/* <ReCaptchaComponent ref={recaptchaRef} onTokenChange={handleTokenChange} /> */}

              <Row justify="center" style={{ marginTop: "1rem" }}>
                <Col span={24}>
                  <Text style={{ color: "white", marginBottom: "4px" }}>
                    Captcha
                  </Text>
                </Col>
                <Col span={24}>
                  <Row justify="start" align="middle">
                    <Col>
                      <Captcha />
                    </Col>
                    <Col style={{ marginLeft: "8px" }}>
                      <ReloadOutlined
                        onClick={reloadCaptcha}
                        style={{
                          cursor: "pointer",
                          color: "#fff",
                        }}
                      />
                    </Col>
                  </Row>
                </Col>
              </Row>

              <Row justify="start" align="middle" style={{ marginTop: "1rem" }}>
                <Col span={24}>
                  <Form.Item
                    label={
                      <span style={{ color: "white" }}>
                        Type the text displayed above
                      </span>
                    }
                    name="captcha"
                    className="captcha-form"
                    rules={[
                      {
                        required: true,
                        message: "Please Enter Captcha",
                      },
                      {
                        pattern: /^[A-Za-z0-9]{1,6}$/,
                        message: "Enter valid Captcha",
                      },
                    ]}
                  >
                    <Input
                      placeholder="Enter Captcha"
                      className={`${!!captchaError ? "captch-input" : ""}`}
                    />
                  </Form.Item>
                  {!!captchaError && (
                    <div className="captch-error">
                      Please enter the correct captcha to proceed.
                    </div>
                  )}
                </Col>
                {/* <Col span={24} className="mt1">
                  <Form.Item
                    label="Select Role"
                    name="userRole"
                    rules={[
                      { required: true, message: "Please select a role" },
                    ]}
                  >
                    <Radio.Group>
                      <Radio value="maker">Maker</Radio>
                      <Radio value="checker">Checker</Radio>
                      <Radio value="employee">Employee</Radio>
                    </Radio.Group>
                  </Form.Item>
                </Col> */}
              </Row>

              <Form.Item>
                <Button
                  htmlType="submit"
                  className="loginButton primaryButton mt1"
                  disabled={loginLoading}
                >
                  Login
                </Button>
                <Link to={RouteConstants.FORGOTPASSWORD}>
                  <span
                    className="text-dim ml2 cursor"
                    style={{ color: "white" }}
                  >
                    Forgot password?
                  </span>
                </Link>
              </Form.Item>
            </Form>
            <div className=""></div>

            {/* <div className="mt2">
              <span className="text-dim" style={{ color: "var(--text-primary)" }}>Or</span>
              <span
                className="mlHalf cursor emp-text"
                onClick={() => setIsEmp((bool) => !bool)}
              >
                Login with {isEmp ? "email" : "employee ID"}
              </span>
            </div> */}
            <div className="mt2 flex-center">
              <span className="text-dim footer-note" style={{ color: "#fff" }}>
                Don't have an account yet? Click here to{" "}
                <b
                  style={{ color: "#fff" }}
                  className="cursor"
                  onClick={() => {
                    history.push("/request-demo");
                  }}
                >
                  {" "}
                  Register for Free Demo
                </b>
                <br />
                <b
                  style={{ color: "#fff" }}
                  className="cursor"
                  onClick={() => {
                    setIsModalVisible(true);
                  }}
                >
                  {" "}
                  Information and Policies
                </b>
              </span>
            </div>

            <div>
              {isModalVisible && (
                <Modal
                  style={{
                    top: 20,
                  }}
                  visible={isModalVisible}
                  onCancel={() => setIsModalVisible(false)}
                  footer={[]}
                  width={"100%"}
                  className="police_modal"
                >
                  <InfoNPolicy />
                </Modal>
              )}
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default LoginForm;
